export const D3_ENERGY_RATE = 0.128622;
export const DEFAULT_LOAD_PROFILE_YEAR = 2019;
export const KWH_TO_MPGE = 33.705;
